import { render, staticRenderFns } from "./ReviewCardAlert.vue?vue&type=template&id=5a66b2a8&"
import script from "./ReviewCardAlert.vue?vue&type=script&lang=ts&setup=true&"
export * from "./ReviewCardAlert.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a66b2a8')) {
      api.createRecord('5a66b2a8', component.options)
    } else {
      api.reload('5a66b2a8', component.options)
    }
    module.hot.accept("./ReviewCardAlert.vue?vue&type=template&id=5a66b2a8&", function () {
      api.rerender('5a66b2a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuReviews/components/ReviewCardAlert.vue"
export default component.exports